import { createFileRoute } from '@tanstack/react-router';
import { PrivacyNoticePage } from '../../features/privacyNotice/pages/PrivacyNoticePage';

export const Route = createFileRoute('/_app/privacyNotice')({
  component: privacyNoticeRouteComponent,
});

function privacyNoticeRouteComponent() {
  return <PrivacyNoticePage />;
}
